import { Tag, Flex } from "@chakra-ui/react";
import { useMemo } from "react";
import moment from "moment";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { TenantUsuarioItem } from "core/features/tenants/typings/tenant";
import { TipoTenantEnum } from "core/resources/enums/tenant";

function useListagemUsuariosTenantColumns() {
  const { tenant } = useCurrentTenant();

  return useMemo(() => {
    const menus = [
      {
        title: "Usuario",
        render: (original: TenantUsuarioItem) => (
          <div>{original.pessoa.nome}</div>
        ),
      },
      {
        title: "E-mail",
        render: (original: TenantUsuarioItem) => <div>{original.email}</div>,
      },
      {
        title: "Data de fim de acesso",
        render: (original: TenantUsuarioItem) => (
          <div>
            {original.dataFimAcesso
              ? moment(original.dataFimAcesso).format("DD/MM/YYYY")
              : "--"}
          </div>
        ),
      },
    ];

    if (
      [TipoTenantEnum.Administradora, TipoTenantEnum.Incorporadora].includes(
        tenant.tipoTenantId
      )
    ) {
      menus.push({
        title: "Condomínios",
        render: (pessoa: TenantUsuarioItem) => (
          <div>{pessoa.numeroCondominios}</div>
        ),
      });
    }

    menus.push({
      title: "Cargo",
      render: (original: TenantUsuarioItem) => (
        <Flex gap="8px">
          {original.perfis.map((perfil: any, index: number) => (
            <Tag
              variant="outline"
              fontSize="12px"
              colorScheme="orange"
              py="6px"
              rounded="full"
              key={index}
            >
              {perfil.nome}
            </Tag>
          ))}
        </Flex>
      ),
    });

    return menus;
  }, [tenant.tipoTenantId]);
}

export default useListagemUsuariosTenantColumns;
